import React from 'react'
import { Col, Container, Row, Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import UseSignUp from '../../CustomHooks/Auth/UseSignUp'
import { ToastContainer } from 'react-toastify'
import logo from "./../../images/logo.png"


const Register = () => {
  const [isPress, loading, userName, userMail, userPhone, userPassword, userConfirmPassword,
    OnChangeUserName, OnChangeUserMail, OnChangeUserPhone, OnChangeUserPassword, OnChangeUserConfirmPassword, RegisterSubmit, UserNameValidation, UserEmailValidation, UserPhoneValidation, UserPasswordValidation, UserPasswordConfirmationValidation, isFormValid] = UseSignUp()
  return (
    <Container className='mh-100vh d-flex justify-content-center align-items-center'>
      <Row>
        <Col sm="12" className="d-flex flex-column">
          <Link to="/">
            <img src={logo} alt='login-icon' className='w-200px mx-auto d-block mb-4' />
          </Link>
          <label className="mx-auto fs-20 mb-2 fw-bold"> Create a new account </label>
          <p className='text-center mb-2'>Register with us to get your favorite products.</p>
          <input
            value={userName}
            onChange={OnChangeUserName}
            onBlur={UserNameValidation}
            placeholder="User Name ..."
            type="text"
            className="form-control mt-3 text-center mx-auto"
          />
          <input
            value={userMail}
            onChange={OnChangeUserMail}
            onBlur={UserEmailValidation}
            placeholder="E-mail..."
            type="email"
            className="form-control mt-3 text-center mx-auto"
          />
          <input
            value={userPhone}
            onChange={OnChangeUserPhone}
            onBlur={UserPhoneValidation}
            placeholder="Phone Number..."
            type="text"
            className="form-control mt-3 text-center mx-auto"
          />
          <input
            value={userPassword}
            onChange={OnChangeUserPassword}
            onBlur={UserPasswordValidation}
            placeholder="Password ..."
            type="password"
            className="form-control mt-3 text-center mx-auto"
          />
          <input
            value={userConfirmPassword}
            onChange={OnChangeUserConfirmPassword}
            onBlur={UserPasswordConfirmationValidation}
            placeholder="Confirm Password ..."
            type="password"
            className="form-control mt-3 text-center mx-auto"
          />
          <button className="btn mx-auto mt-4 orange-bg fw-bold text-white w-100" onClick={RegisterSubmit} disabled={!isFormValid}>
            {isPress ? loading ? <Spinner variant='light' animation='border' /> : <span>Register</span> : <span>Register</span>}
          </button>
          <label className="mx-auto my-4">
            Are you have an account ?{" "}
            <Link to="/login">
              <span className="orange-color fw-bold">
                Click here
              </span>
            </Link>
          </label>
        </Col>
      </Row>
      <ToastContainer limit={3} />
    </Container>
  )
}

export default Register
